// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface AirwallexConfigOut {}

export const AirwallexConfigOutSerializer = {
  _fromJsonObject(_object: any): AirwallexConfigOut {
    return {};
  },

  _toJsonObject(_self: AirwallexConfigOut): any {
    return {};
  },
};
